import { MenuLinkItemProps } from '@creditornot/cb-menu';
import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import MenuLinkItemRRD from 'common/components/MenuLinkItemRRD';
import LazyLoadedThumbnail from 'modules/menu/components/LazyLoadedThumbnail';

type Props = {
  dropActive?: boolean;
  exact?: boolean;
  imageBlurhash?: string;
  imageUrl?: string;
  isDroppable?: boolean;
  label: React.ReactNode;
  numberOfItems: number;
} & MenuLinkItemProps;

const NavigationItem = ({
  isDroppable,
  imageUrl,
  imageBlurhash,
  dropActive,
  href,
  numberOfItems,
  exact = false,
  label,
  ...rest
}: Props) => {
  const match = useRouteMatch({
    path: href,
    exact,
  });
  return (
    <MenuLinkItemRRD
      active={!!match || isDroppable || dropActive}
      rightContent={<>{numberOfItems}</>}
      icon={
        imageUrl && <LazyLoadedThumbnail size="tiny" alt={imageUrl} blurhash={imageBlurhash ?? null} src={imageUrl} />
      }
      href={href}
      {...rest}
    >
      {label}
    </MenuLinkItemRRD>
  );
};

export default React.memo(NavigationItem);
